<div id="container">
    <div id="header">Mood Tracker</div>
    <div id="header_score">Score: {{localMoodScore}}</div>
    <div id="faceSelector">
        <div (click)="modifyScore(2)" id="selectButton">😁 Happy</div>
        <div (click)="modifyScore(1)" id="selectButton">😐 Neutral</div>
        <div (click)="modifyScore(-2)" id="selectButton">😭 Sad</div>
    </div>
</div>
